import { api_configuration } from "../../../common";
import api_client_state = api_configuration.types.client_state.alan_api;
import csd = api_configuration.types.client_state.alan_api;
import * as reQuery from "../../state 2 interface/reQuery";
import { addMessage } from "../../front/messages";
import clock from "../../state/clock";

type State = [string, any];

export function numberColumnOperator(
	state: api_client_state.Cyes__has_filter__number,
	operator: Extract<csd.Tyes__operator_selected["operator"], State>[0]
): void {
	state.properties.operator_selected.set("yes", {
		operator: [operator, {}],
	});
	state.properties.criteria_is_valid.switch({
		yes: function () {
			reQuery.execute(state.parent.parent.parent);
		},
		no: undefined,
	});
	switch (operator) {
		case "equal to": {
			state.properties.filter_range.ensure("not available", {});
			break;
		}
		case "smaller than or equal to":
		case "smaller than": {
			switch (state.properties.filter_range.state.name) {
				case "no": {
					break;
				}
				case "yes": {
					const range_filter = state.properties.filter_range.state.node;
					switch (range_filter.properties.operator.state.name) {
						case "smaller than": {
							const smaller_than = range_filter.properties.operator.state.node;
							range_filter.properties.operator.ensure("greater than", {
								"or equal to": smaller_than.properties.or_equal_to.switch({
									no: "no",
									yes: "yes",
								}),
							});
							break;
						}
						case "greater than": {
							break;
						}
					}
					break;
				}
				case "not available": {
					state.properties.filter_range.ensure("no", {});
					break;
				}
			}
			break;
		}
		case "greater than or equal to":
		case "greater than": {
			switch (state.properties.filter_range.state.name) {
				case "no": {
					break;
				}
				case "yes": {
					const range_filter = state.properties.filter_range.state.node;
					switch (range_filter.properties.operator.state.name) {
						case "greater than": {
							const greater_than = range_filter.properties.operator.state.node;
							range_filter.properties.operator.ensure("smaller than", {
								"or equal to": greater_than.properties.or_equal_to.switch({
									no: "no",
									yes: "yes",
								}),
							});
							break;
						}
						case "smaller than": {
							break;
						}
					}
					break;
				}
				case "not available": {
					state.properties.filter_range.ensure("no", {});
					break;
				}
			}
			break;
		}
	}
}

export function numberColumn(state: api_client_state.Cyes__has_filter__number, filter_value: number): void {
	reQuery.stopDelayingQuery(state.parent.parent.parent);
	const mutable_state = state;
	if (!isNaN(filter_value) && filter_value === Math.floor(filter_value)) {
		mutable_state.properties.filter_set.set("yes", {});
		mutable_state.properties.criteria_is_valid.set("yes", {
			criteria: filter_value,
		});
	} else {
		mutable_state.properties.filter_set.set("no", {});
		mutable_state.properties.criteria_is_valid.set("no", {});
	}
	reQuery.execute(state.parent.parent.parent);
}
export function numberColumnRange(state: api_client_state.Cyes__filter_range, filter_value: number): void {
	reQuery.stopDelayingQuery(state.parent.parent.parent.parent);
	if (!isNaN(filter_value) && filter_value === Math.floor(filter_value)) {
		state.properties.criteria_is_valid.set("yes", {
			criteria: filter_value,
		});
	} else {
		state.properties.criteria_is_valid.set("no", {});
	}
	reQuery.execute(state.parent.parent.parent.parent);
}
const maximum_text_filter_length = 1000;
export function textColumn(
	state: api_client_state.Cyes__has_filter__text,
	criteria: string,
	operation: Extract<csd.Tyes__has_filter__text["operation"], string>
): void {
	if (criteria.length > maximum_text_filter_length) {
		// truncate the criteria, because it will otherwise conflicts with the expression
		// that is build using the collation table. This will prevent a maximum call stack
		// exceeded error.
		criteria = criteria.substring(0, maximum_text_filter_length);
		addMessage("warning", "Text filter limit exceeded.");
	}
	reQuery.stopDelayingQuery(state.parent.parent.parent);
	state.set_value(criteria);
	state.properties.operation.set(operation, {});
	state.properties.filter_set.ensure("yes", {});
	reQuery.execute(state.parent.parent.parent);
}

export function enableStateGroupColumn(state: api_client_state.Cno__filter_enabled): void {
	reQuery.stopDelayingQuery(state.parent.parent.parent.parent);
	const mutable_state = state.parent;
	mutable_state.properties.filter_enabled.set("yes", {});
	state.parent.properties.states.forEach(function ($) {
		$.properties.is_selected.set("no", {});
	});
	reQuery.execute(state.parent.parent.parent.parent);
}
export function disableStateGroupColumn(state: api_client_state.Cyes__filter_enabled): void {
	const mutable_state = state.parent;
	mutable_state.properties.filter_enabled.set("no", {});
	state.parent.properties.states.forEach(function ($) {
		$.properties.is_selected.set("yes", {});
	});
	reQuery.execute(state.parent.parent.parent.parent);
}
export function setStateFilter(state: api_client_state.Cno__is_selected__states__yes): void {
	state.parent.properties.is_selected.set("yes", {});
	reQuery.execute(state.parent.parent.parent.parent.parent);
}

export function unsetStateFilter(state: api_client_state.Cyes__is_selected__states__yes): void {
	state.parent.properties.is_selected.set("no", {});
	reQuery.execute(state.parent.parent.parent.parent.parent);
}

export function resetFilters(query: api_client_state.Cquery__client_state): void {
	for (const [, $] of query.properties.columns) {
		switch ($.properties.type.state.name) {
			case "file":
				break;
			case "number": {
				const number = $.properties.type.state.node;
				switch (number.properties.has_filter.state.name) {
					case "no":
						break;
					case "yes": {
						const $ = number.properties.has_filter.state.node;
						resetNumberFilter($);
						break;
					}
					default:
						unexpectedState(number.properties.has_filter.state);
				}

				break;
			}
			case "state group": {
				const state_group = $.properties.type.state.node;
				switch (state_group.properties.has_filter.state.name) {
					case "no":
						break;
					case "yes": {
						const $ = state_group.properties.has_filter.state.node;
						resetStateGroupFilter($);
						break;
					}
					default:
						unexpectedState(state_group.properties.has_filter.state);
				}
				break;
			}
			case "text": {
				const text = $.properties.type.state.node;
				switch (text.properties.has_filter.state.name) {
					case "no":
						break;
					case "yes": {
						const yes = text.properties.has_filter.state.node;
						resetTextFilter(yes);
						break;
					}
					default:
						unexpectedState(text.properties.has_filter.state);
				}

				break;
			}
			case "widget":
				break;
			default:
				unexpectedState($.properties.type.state);
		}
	}
}

export function resetNumberFilter(state: api_client_state.Cyes__has_filter__number): void {
	state.parent.inferences.number_type().properties.has_filter.switch({
		yes: ($) => {
			$.properties.operator_selected.switch<void>({
				yes: ($) => {
					state.properties.operator_selected.set("yes", {
						operator: $.properties.operator.switch<csd.Tyes__operator_selected["operator"]>({
							"equal to": ["equal to", {}],
							"greater than": ["greater than", {}],
							"greater than or equal to": ["greater than or equal to", {}],
							"smaller than": ["smaller than", {}],
							"smaller than or equal to": ["smaller than or equal to", {}],
						}),
					});
				},
				no: () => state.properties.operator_selected.set("no", {}),
			});
			$.properties.initial_criteria.switch<void>({
				none: () => state.properties.filter_set.set("no", {}),
				yes: () => state.properties.filter_set.set("yes", {}),
			});
			$.properties.initial_criteria.switch<void>({
				none: () => state.properties.criteria_is_valid.set("no", {}),
				yes: (yes__initial_criteria) => {
					state.properties.criteria_is_valid.set("yes", {
						criteria: yes__initial_criteria.properties.source.switch<number>({
							now: (now__source) =>
								clock.getNow() +
								now__source.properties.has_offset.switch({
									none: 0,
									yes: (yes__has_offset) => yes__has_offset.properties.offset.value,
								}),
							static: (static__source) => static__source.properties.number.value,
						}),
					});
				},
			});
			disableRange(state);
		},
		no: undefined,
	});
	reQuery.execute(state.parent.parent.parent);
}

export function resetTextFilter(state: api_client_state.Cyes__has_filter__text): void {
	state.parent.inferences.text_type().properties.filter.switch({
		simple: ($) => {
			const criteria = $.properties.criteria;
			if (criteria.length > 0) {
				state.properties.filter_set.set("yes", {});
			} else {
				state.properties.filter_set.set("no", {});
			}
			state.set_value(criteria);
			state.properties.operation.set("equals", {});
		},
		"current id path": undefined,
		none: undefined,
	});
	reQuery.execute(state.parent.parent.parent);
}

export function resetStateGroupFilter(state: api_client_state.Cyes__has_filter__state_group): void {
	state.parent.inferences.state_group_type().properties.has_filter.switch({
		yes: ($) => {
			$.properties.filter_enabled.switch<void>({
				yes: () => state.properties.filter_enabled.set("yes", {}),
				no: () => state.properties.filter_enabled.set("no", {}),
			});
			$.properties.states.map(($) => {
				$.properties.is_selected.switch<void>({
					yes: () => state.properties.states.get($.key.ref.key.ref.key)!.properties.is_selected.set("yes", {}),
					no: () => state.properties.states.get($.key.ref.key.ref.key)!.properties.is_selected.set("no", {}),
				});
			});
		},
		no: undefined,
	});
	reQuery.execute(state.parent.parent.parent);
}

export function removeFilters(query: api_client_state.Cquery__client_state): void {
	for (const [, $] of query.properties.columns) {
		switch ($.properties.type.state.name) {
			case "file":
				break;
			case "number": {
				const number = $.properties.type.state.node;
				switch (number.properties.has_filter.state.name) {
					case "no":
						break;
					case "yes": {
						const $ = number.properties.has_filter.state.node;
						removeNumberFilter($);
						break;
					}
					default:
						unexpectedState(number.properties.has_filter.state);
				}

				break;
			}
			case "state group": {
				const state_group = $.properties.type.state.node;
				switch (state_group.properties.has_filter.state.name) {
					case "no":
						break;
					case "yes": {
						const $ = state_group.properties.has_filter.state.node;
						removeStateGroupFilter($);
						break;
					}
					default:
						unexpectedState(state_group.properties.has_filter.state);
				}
				break;
			}
			case "text": {
				const text = $.properties.type.state.node;
				switch (text.properties.has_filter.state.name) {
					case "no":
						break;
					case "yes": {
						const yes = text.properties.has_filter.state.node;
						removeTextFilter(yes);
						break;
					}
					default:
						unexpectedState(text.properties.has_filter.state);
				}

				break;
			}
			case "widget":
				break;
			default:
				unexpectedState($.properties.type.state);
		}
	}
}

export function removeNumberFilter(state: api_client_state.Cyes__has_filter__number): void {
	state.properties.operator_selected.set("no", {});
	state.properties.filter_set.set("no", {});
	state.properties.criteria_is_valid.set("no", {});
	disableRange(state);
	reQuery.execute(state.parent.parent.parent);
}

export function removeTextFilter(state: api_client_state.Cyes__has_filter__text): void {
	state.properties.filter_set.set("no", {});
	state.properties.operation.ensure("equals", {});
	state.set_value("");
	reQuery.execute(state.parent.parent.parent);
}

export function removeStateGroupFilter(state: api_client_state.Cyes__has_filter__state_group): void {
	const mutable_state = state;
	mutable_state.properties.filter_enabled.set("no", {});
	state.properties.states.map(function ($) {
		$.properties.is_selected.set("no", {});
	});
	reQuery.execute(state.parent.parent.parent);
}

export function enableRange(state: api_client_state.Cyes__has_filter__number): void {
	state.properties.filter_range.ensure("yes", {
		"criteria is valid": state.properties.criteria_is_valid.switch<
			api_client_state.Tyes__filter_range["criteria is valid"]
		>({
			no: "no",
			yes: ($) => [
				"yes",
				{
					criteria: $.properties.criteria.value,
				},
			],
		}),
		operator: state.properties.operator_selected.switch<api_client_state.Tyes__filter_range["operator"]>({
			no: [
				"smaller than",
				{
					"or equal to": "no",
				},
			],
			yes: ($) =>
				$.properties.operator.switch({
					"equal to": [
						"smaller than",
						{
							"or equal to": "no",
						},
					],
					"smaller than": [
						"greater than",
						{
							"or equal to": "no",
						},
					],
					"smaller than or equal to": [
						"greater than",
						{
							"or equal to": "no",
						},
					],
					"greater than": [
						"smaller than",
						{
							"or equal to": "no",
						},
					],
					"greater than or equal to": [
						"smaller than",
						{
							"or equal to": "no",
						},
					],
				}),
		}),
	});
	reQuery.execute(state.parent.parent.parent);
}

export function disableRange(state: api_client_state.Cyes__has_filter__number): void {
	state.properties.filter_range.ensure("no", {});
	reQuery.execute(state.parent.parent.parent);
}

export function rangeGreaterThan(state: api_client_state.Cgreater_than__operator__yes__filter_range): void {
	state.properties.or_equal_to.ensure("no", {});
	reQuery.execute(state.parent.parent.parent.parent.parent);
}

export function rangeGreaterThanOrEqualTo(state: api_client_state.Cgreater_than__operator__yes__filter_range): void {
	state.properties.or_equal_to.ensure("yes", {});
	reQuery.execute(state.parent.parent.parent.parent.parent);
}

export function rangeSmallerThan(state: api_client_state.Csmaller_than__operator__yes__filter_range): void {
	state.properties.or_equal_to.ensure("no", {});
	reQuery.execute(state.parent.parent.parent.parent.parent);
}

export function rangeSmallerThanOrEqualTo(state: api_client_state.Csmaller_than__operator__yes__filter_range): void {
	state.properties.or_equal_to.ensure("yes", {});
	reQuery.execute(state.parent.parent.parent.parent.parent);
}
